import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-development',
  templateUrl: './icon-development.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconDevelopmentComponent {}
